import React, { useState, useEffect } from "react"
import "./EditManagePatients.scss"
import { useHistory, useLocation, useParams } from "react-router"
import { addNewPatient, getPatientDetail } from "../../../../core/services/api"
import PatientEditForm from "../../../../components/patientEditForm/patientEditForm"
import Toast from "../../../../components/Toast"
import { useSelector } from "react-redux"
import { MocUserRole } from "core/services/models/Enums"
import { calculateAge } from "core/utils/date"


function EditManagePatients() {
  const history = useHistory()
  const [displayToast, toggleToast] = useState<any>()
  const { patientId }: any = useParams()
  const userRole = useSelector((state: any) => state.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const [patientInfo, setpatientInfo] = useState<object>({
    centers: userDetail?.centers,
    ageString: "Please Select Dob To Calculate Age.",
  })
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const location = useLocation();
  const centerID = location?.state?.centerId
  // @ts-ignore
  let readOnly = useSelector((state) => state?.user?.readOnly);



  useEffect(() => {
    if (patientId) {
      // setIsLoading(true)
      getPatientDetail(patientId)
        .then((res: any) => {
          const temp = { ...res }
          temp["ageString"] = calculateAge(res?.dob)
          let name = res?.name?.split(" ")
          temp["firstName"] = name.shift()
          temp["lastName"] = name.join("")
          setpatientInfo(temp)
          setIsLoading(false)
        })
        .catch((err) => {
          console.log("err", err)
          setIsLoading(false)
        })
    }
  }, [patientId])

  const handleOnSubmit = (patientInfo: any, consentData: any) => {
    // setIsLoading(true)
    const temp = { ...patientInfo }
    temp["name"] = `${patientInfo?.firstName ? patientInfo?.firstName?.trim() : ""} ${patientInfo?.lastName ? patientInfo?.lastName?.trim() : ""}`
    temp["generalConsent"] = consentData
    temp["category"] = temp["category"].toUpperCase()
    if (temp["referredBy"] === "referredByOthers") {
      temp["referredBy"] = temp["referredByOthers"]
    }
    if (temp["referredBy"] && temp["referredBy"]["doctorName"] === "Others") {
      if (temp["referredBy"]["doctorNameOthers"]) {
        temp["referredBy"]["doctorName"] =
          temp["referredBy"]["doctorNameOthers"]
      }
    }
    if (temp?.tags !== null) {
      let tagValue = temp?.tags?.map((item: any) => {
        return item?.value
      })
      temp["tags"] = tagValue
    }
    delete temp["ageString"]
    delete temp["firstName"]
    delete temp["lastName"]
    delete temp["referredByOthers"]
    delete temp["refunds"]
    delete temp["totalPendingInvoices"]
    delete temp["advancePayment"]
    delete temp["totalAdvancePayment"]
    delete temp["isEditedAlready"]
    delete temp["securityDeposit"]
    delete temp["totalPendingAmount"]
    if (temp && temp["referredBy"] && temp["referredBy"]["doctorNameOthers"]) {
      delete temp["referredBy"]["doctorNameOthers"]
    }
    delete temp["oldDocuments"]


    if (temp["documents"]) delete temp["documents"]
    addNewPatient(temp)
      .then((data) => {
        console.log("data ------>", data)
        setIsLoading(false)
        toggleToast({
          type: "success",
          text: data?.isNameChanged ? `Patient - ${data?.mocId} detail updated successfully. Patient name is being updated in all previous records, will notify after completion` : `Patient - ${data?.mocId} detail updated successfully`,
        })
      })
      .catch((err) => {
        setIsLoading(false)
        console.log(err)
        toggleToast({
          type: "error",
          text: err?.response?.data?.message
            ? err?.response?.data?.message
            : "Unable to edit patient at the moment. Please try again after sometime",
        })
      })
  }
  return (
    <>
      {
        isLoading ? (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "50%",
            }}
          >
            <div
              style={{ width: "3rem", height: "3rem" }}
              className="spinner-border text-primary"
            ></div>
          </div >
        ) : (
          <div className="edit-manage-patient-container">
            <div className="d-flex">
              <div
                className="back-image"
                onClick={() => {
                  history.push({
                    pathname: "/managePatients",
                    state: {
                      centerId: centerID
                    }
                  })
                }}
              >
                <img
                  src="../../assets/images/back-icon.svg"
                  height={"60px"}
                  width={"60px"}
                  alt="back button"
                />

              </div>
              <div className="edit-patient-heading">Edit Manage Patient</div>
            </div>


            {displayToast && userRole !== MocUserRole.SYSTEM_ADMIN && (
              <Toast
                textMessage={displayToast?.text}
                onClose={() => {
                  history.push(`/patientList/${patientId}`)
                  toggleToast(false)
                }}
                onCloseText={"Close"}
                type={displayToast?.type}
              />
            )}
            {displayToast && userRole === MocUserRole.SYSTEM_ADMIN && (
              <Toast
                textMessage={displayToast?.text}
                onClose={() => {
                  if (displayToast?.type === "error") {
                    toggleToast(false);
                  } else {
                    history.push({
                      pathname: "/managePatients",
                      state: {
                        centerId: centerID
                      }
                    })
                    toggleToast(false)
                  }
                }}
                onCloseText={"Close"}
                type={displayToast?.type}
              />
            )}
            {displayToast && userRole === MocUserRole.CENTER_ADMIN && (
              <Toast
                textMessage={displayToast?.text}
                onClose={() => {
                  if (displayToast?.type === "error") {
                    toggleToast(false);
                  } else {
                    history.push(`/managePatients`)
                    toggleToast(false)
                  }
                }}
                onCloseText={"Close"}
                type={displayToast?.type}
              />
            )}
            <PatientEditForm
              previousState={location.state.previousState}
              patientDetail={patientInfo}
              onSubmit={handleOnSubmit}
              userRole={userRole}
              userDetail={userDetail}
            />
          </div>
        )
      }
    </>
  )
}
export default EditManagePatients
